import { JobStatuses } from './job';

export type JobStatusConfig = {
    label: string;
    color: string;
};

export const JOB_STATUS_COLOR_MAP: Record<JobStatuses, JobStatusConfig> = {
    [JobStatuses.NEW]: { label: 'Draft', color: 'var(--gray-6)' },
    [JobStatuses.PROPOSED]: { label: 'Proposed', color: 'var(--gray-6)' },
    [JobStatuses.IN_PROGRESS]: { label: 'Live', color: 'var(--polar-green-6)' },
    [JobStatuses.ACCEPTED]: { label: 'Accepted', color: 'var(--polar-green-6)' },
    [JobStatuses.COMPLETED]: { label: 'Cleared', color: 'var(--brand-6)' },
    [JobStatuses.CLOSED]: { label: 'Closed', color: 'var(--brand-6)' },
    [JobStatuses.REJECTED]: { label: 'Rejected', color: 'var(--dust-red-6)' },
    [JobStatuses.AWAITING_PAYMENT]: { label: 'Awaiting Payment', color: 'var(--orange-6)' },
    [JobStatuses.PARTIALLY_PAID]: { label: 'Partially Paid', color: 'var(--orange-6)' },
    [JobStatuses.OVERDUE]: { label: 'Overdue', color: 'var(--dust-red-6)' },
};
